<template>
    <div class="backconrtM">
        <!-- <div class="camera">
      <div class="cameraClick" @click="openCamera"></div>
    </div> -->
        <div style="display: none;" class="backCourt-em">
            <div class="emCon">
                <el-carousel indicator-position="none" height="100%" direction="vertical">
                    <!-- <el-carousel-item>
            <div>PM2.5</div>
            <div>{{ Environmental.pm25 ? Environmental.pm25 : "" }}μg/m³</div>
          </el-carousel-item>
          <el-carousel-item>
            <div>PM1.0</div>
            <div>{{ Environmental.pm10 ? Environmental.pm10 : "" }}μg/m³</div>
          </el-carousel-item> -->
                    <el-carousel-item>
                        <div>温度</div>
                        <div>
                            {{
                                Environmental.envTemperature
                                    ? Environmental.envTemperature.toFixed(2)
                            : ""
                            }}°C
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div>湿度</div>
                        <div>
                            {{
                                Environmental.envHumidity
                                    ? Environmental.envHumidity.toFixed(1)
                            : ""
                            }}hPa
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div>气压</div>
                        <div>
                            {{
                                Environmental.airPressure
                                    ? Environmental.airPressure.toFixed(2)
                            : ""
                            }}Pa
                        </div>
                    </el-carousel-item>
                    <!-- <el-carousel-item>
            <div>光照度</div>
            <div>{{Environmental.illuminance?Environmental.illuminance.toFixed(2):''}}μg/m³</div>
          </el-carousel-item> -->
                    <!-- <el-carousel-item>
            <div>噪声</div>
            <div>{{Environmental.noise?Environmental.noise:''}}μg/m³</div>
          </el-carousel-item> -->
                    <el-carousel-item
                        v-if="Environmental.windDirection && Environmental.windDirection.indexOf('?') == -1">
                        <div>风向</div>
                        <div>
                            {{
                                Environmental.windDirection ? Environmental.windDirection : ""
                            }}
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div>风速</div>
                        <div>
                            {{
                                Environmental.windSpeed
                                    ? Environmental.windSpeed.toFixed(2)
                            : ""
                            }}mps
                        </div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <div>风力</div>
                        <div>
                            {{ Environmental.windPower ? Environmental.windPower : "" }}级
                        </div>
                    </el-carousel-item>
                    <!-- <el-carousel-item>
            <div>喷淋状态</div>
            <div>{{Environmental.status?Environmental.status:''}}</div>
          </el-carousel-item> -->
                </el-carousel>
            </div>
        </div>
        <div class="italics">
            <div class="italicsTitle">
                {{ mixName ? mixName : "暂无拌合楼生产" }}
            </div>
            <el-row>
                <el-col :span="12" style="width:45%">
                    <div>
                        累计拌和<span> {{ Mixing }}</span>
                        <!-- 累计拌和<span> 1228.2t</span> -->
                    </div>
                </el-col>
                <el-col :span="12" style="width:55%">
                    <div>
                        单位小时产量<span> {{ yieldW }}</span>
                        <!-- 单位小时产量<span> 421.1t</span> -->
                    </div>
                </el-col>
                <template v-if="isType == 'lq'">
                    <el-col :span="12" style="width:48%">
                        <div>
                            油石比均值<span> {{ meanValue }}</span>
                        </div>
                    </el-col>
                </template>
                <template v-else>
                    <el-col :span="12">
                        <div>
                            水泥含量均值<span> {{ meanValue }}</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            水泥含量合格率<span> {{ Ratio }}</span>
                        </div>
                    </el-col>
                </template>
                <el-col :span="12" v-if="isType == 'lq'" style="width:52%">
                    <div>
                        油石比合格率<span> {{ OilRatio }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- <div class="transportWave">
            <div class="Wave1" @click="openTripModal">
                在途料车<span>{{ onTheWay ? onTheWay : "-/-" }}</span>
            </div>
            <div class="Wave2" @click="openTripModal">
                运输车数量<span>{{ transportNum ? transportNum : "-/-" }}</span>
            </div>
            <div class="Wave3" @click="openTripModal">
                运输总车次<span>{{ transportTotal ? transportTotal : "-/-" }}</span>
            </div>
            <div class="Wave4" @click="openTripModal">
                平均运输时间<span>{{
                    transportAverage || transportAverage == 0
                        ? transportAverage + "min"
                    : "-/-"
                    }}</span>
            </div>
            <div class="Wave5" @click="openTripModal">
                运输时间异常<span>{{
                    timeAbnormal ? timeAbnormal + "车料" + "(" + percentage + "%)" : "-/-"
                    }}</span>
            </div>
        </div> -->
        <div class="slkVideo" @click="openhcCamera('slkVideo')">上料口</div>
        <div class="lqjzkVideo" @click="openhcCamera('lqjzkVideo')">沥青加注口</div>
        <div class="clkVideo" @click="openhcCamera('clkVideo')">出料口</div>
        <div class="clkPlate" v-if="chargingPlate">{{ chargingPlate }}</div>
        <!-- <div class="clkPlate" >苏A123456</div> -->
        <div class="yclkVideo" @click="openhcCamera('yclkVideo')">原材料口</div>
        <!-- 运输车次弹框 -->
        <trip-info ref="tripInfo" :type="type" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import TripInfo from "./components/tripInfo.vue";
import {
    getKeyLabel,
    getCement,
    getTransportTodaySummary,
    getCurrentTime,
    getInitScreenData,
    getRealChannel
} from "@/api/api";
export default {
    components: {
        TripInfo
    },
    props: {
        type: "",
    },
    data() {
        return {
            currentDate: "",
            currentTime: "",
            isType: "",
            // 后场
            Mixing: "",
            yieldW: "",
            meanValue: "",
            OilRatio: "",
            Ratio: '',
            // 运输
            onTheWay: "",
            chargingPlate: "",
            transportNum: "",
            transportTotal: "",
            transportAverage: "",
            timeAbnormal: "",
            percentage: "",
            mixName: "",
            Environmental: {},
            isOpen: false,
            labelRequestToken: 0,
            cementRequestToken: 0,
            transportRequestToken: 0,
        };
    },
    created() {
        this.dataRefreh();
    },
    mounted() {
        this.isType = this.type;
        const timeMachine = getCurrentTime();
        this.currentDate = timeMachine.split(" ")[0];
        this.currentTime = timeMachine.split(" ")[1];
        if (this.mixplantId) {
            this.refreshBackCourtStats();
        }
    },
    beforeDestroy() {
        this.clear();
    },
    methods: {
        // 定时刷新数据函数
        dataRefreh() {
            // 计时器正在进行中，退出函数
            if (this.intervalId != null) {
                return;
            }
            // 计时器为空，操作
            this.intervalId = setInterval(() => {
                this.refreshBackCourtStats();
            }, 30000);
        },
        // 停止定时器
        clear() {
            clearInterval(this.intervalId); //清除计时器
            this.intervalId = null; //设置为null
        },
        // 切换拌合站后统一刷新后场统计，避免名称与指标错位
        refreshBackCourtStats() {
            if (!this.mixplantId) return;
            this.mixName = this.mixplantName || "";
            this.getkeyLabels();
            if (this.isType != "lq") {
                this.getCements();
            }
            this.getTotalCar();
        },
        // 与 survey 选中站作业面保持一致，缺省再回退当前顶部作业面
        resolveQueryWorkAreaId() {
            if (
                this.mixplantWorkAreaId != null &&
                this.mixplantWorkAreaId !== ""
            ) {
                return this.mixplantWorkAreaId;
            }
            return this.sectionId;
        },
        resolveQueryMixtureId() {
            if (
                this.mixplantMixtureId != null &&
                this.mixplantMixtureId !== ""
            ) {
                return this.mixplantMixtureId;
            }
            return "";
        },
        // 获取后场信息
        async getkeyLabels() {
            const token = ++this.labelRequestToken;
            const mixplantId = this.mixplantId;
            const displayName = this.mixplantName || "";
            const workAreaId = this.resolveQueryWorkAreaId();
            const mixtureId = this.resolveQueryMixtureId();
            if (!mixplantId) return;
            let req = {
                endDate: this.currentDate,
                mixplantId: mixplantId,
                sectionId: this.seIds,
                startDate: this.currentDate,
                workAreaId: workAreaId,
                mixtureId: mixtureId,
            };
            const mpDataLQ = await getKeyLabel(this.type, req);
            // 过期请求丢弃，防止快速切换后旧数据覆盖新站
            if (token !== this.labelRequestToken) return;
            if (String(mixplantId) !== String(this.mixplantId)) return;

            this.mixName = displayName || this.mixplantName || "";
            this.Mixing = mpDataLQ.data.weight ? mpDataLQ.data.weight + " t" : "-/-";
            this.yieldW = mpDataLQ.data.perHourWeight
                ? mpDataLQ.data.perHourWeight + "t/h"
                : "-/-";
            if (this.type == "lq") {
                this.meanValue = mpDataLQ.data.oilYieldAvg
                    ? (mpDataLQ.data.oilYieldAvg * 100).toFixed(2) + "%"
                    : "-/-";
            }
            this.OilRatio = mpDataLQ.data.oilYield
                ? mpDataLQ.data.oilYield + "%"
                : "-/-";
        },
        // 获取后场信息均值合格率
        async getCements() {
            const token = ++this.cementRequestToken;
            const mixplantId = this.mixplantId;
            const workAreaId = this.resolveQueryWorkAreaId();
            const mixtureId = this.resolveQueryMixtureId();
            if (!mixplantId) return;
            let req = {
                endDate: this.currentDate,
                mixplantId: mixplantId,
                sectionId: this.seIds,
                startDate: this.currentDate,
                workAreaId: workAreaId,
                mixtureId: mixtureId,
            };
            const cementLQ = await getCement(this.type, req);
            if (token !== this.cementRequestToken) return;
            if (String(mixplantId) !== String(this.mixplantId)) return;

            this.mixName = this.mixplantName || "";
            const list =
                cementLQ &&
                cementLQ.data &&
                cementLQ.data.collect &&
                cementLQ.data.collect.list
                    ? cementLQ.data.collect.list
                    : [];
            this.meanValue =
                list.length > 0 ? list[0].avgValue.toFixed(2) + "%" : "-/-";
            this.Ratio = list.length > 0 ? list[0].yield + "%" : "-/-";
        },
        async openhcCamera(key) {
            // 根据 key 获取对应的 site 值
            const siteMap = {
                'slkVideo': 1,      // 上料口
                'lqjzkVideo': 2,    // 沥青加注口
                'clkVideo': 3,      // 出料口
                'yclkVideo': 4      // 原材料口
            }

            const targetSite = siteMap[key]
            if (!targetSite) {
                this.$message({
                    message: '未知的监控设备',
                    type: 'warning'
                })
                return
            }

            // 直接通过 store 传递 site 值，不调用接口
            this.$store.commit('updataHcCameraKey', '')
            this.$nextTick(() => {
                this.$store.commit('updataHcCameraKey', key)
            })
        },
        // 开启监控
        async openCamera() {
            let req = {
                engineeringId: this.engineerId,
                workareaId: this.sectionId,
                site: 2  //1前2后
            };
            // 前置获取是否有视频流返回
            const ertData = await getRealChannel(req);
            if (ertData.data.length != 0) {
                this.isOpen = !this.isOpen
                this.$store.commit("updataMixplantOpen", this.isOpen)
            } else {
                this.$message({
                    message: '暂无视频数据',
                    type: 'warning'
                });
            }

        },
        async getEnvironmental() {
            let req = {
                // engineeringConfigId:this.engineerId
                engineeringConfigId: 1,
            };
            const ertData = await getInitScreenData(req);
            console.log(ertData.data)
            console.log(ertData.data.resultData)
            if (ertData.status == 200) {
                this.Environmental = ertData.data.resultData ? ertData.data.resultData : {};
            }
        },
        // 获取运输统计及装料中车牌
        async getTotalCar() {
            const token = ++this.transportRequestToken;
            const mixplantId = this.mixplantId;
            if (!mixplantId) return;
            let req = {
                materialType: this.type || 'lq',
                mixplantId: mixplantId,
                sectionId: this.seIds
            };
            try {
                const res = await getTransportTodaySummary(req);
                if (token !== this.transportRequestToken) return;
                if (String(mixplantId) !== String(this.mixplantId)) return;
                if (res && res.data) {
                    const d = res.data;
                    this.onTheWay = (d.inTransit && d.inTransit.carCount) || 0;
                    const carNos = (d.loading && d.loading.carNos) || [];
                    this.chargingPlate = carNos[0] || '';
                    this.transportNum = d.todayCarCount || 0;
                    this.transportTotal = d.todayTransportCount || 0;
                    this.transportAverage = d.avgTransportDuration || 0;
                    this.timeAbnormal = d.overTimeCount || 0;
                    this.percentage = d.upLimitRatio || 0;
                }
            } catch (e) {
                console.error('获取统计数据失败', e);
            }
        },
        // 获取总车次
        openTripModal() {
            this.$refs.tripInfo && this.$refs.tripInfo.open();
        }
    },
    computed: mapState([
        "engineerId",
        "sectionId",
        "workAreaId",
        "mixplantId",
        "mixplantName",
        "mixplantWorkAreaId",
        "mixplantMixtureId",
        "seIds"
    ]),
    watch: {
        isType(curVal, oldVal) {
            this.getEnvironmental();
        },
        engineerId(curVal, oldVal) {
            this.getEnvironmental();
        },
        // 作业面切换由 survey 清空并重选拌合站，后场只跟 mixplantId
        workAreaId(curVal, oldVal) { },
        mixplantId(curVal, oldVal) {
            if (String(curVal) === String(oldVal)) return;
            if (!curVal) {
                this.mixName = "";
                this.Mixing = "";
                this.yieldW = "";
                this.meanValue = "";
                this.OilRatio = "";
                this.Ratio = "";
                this.onTheWay = "";
                this.chargingPlate = "";
                this.transportNum = "";
                this.transportTotal = "";
                this.transportAverage = "";
                this.timeAbnormal = "";
                this.percentage = "";
                return;
            }
            this.refreshBackCourtStats();
        },
        mixplantName(curVal) {
            this.mixName = curVal || "";
        },
    },
};
</script>

<style lang="less" scoped>
.backconrtM {
    position: absolute;
    width: 100%;
    height: 100%;

    .slkVideo,
    .lqjzkVideo,
    .clkVideo,
    .yclkVideo {
        position: absolute;
        width: 84px;
        height: 96px;
        line-height: 55px;
        text-align: center;
        padding-left: 40px;
        color: #fff;
        font-size: 14px;
        font-weight: 900;
        text-shadow: 0.1em 0.1em 0.05em #000;
        background-image: url(../assets/img/hcsxt.png);
        background-size: 100% 100%;
        cursor: pointer;
    }

    .slkVideo {
        top: 45px;
        left: 15px;
    }

    .lqjzkVideo {
        top: 125px;
        left: 145px;
    }

    .clkVideo {
        top: 135px;
        left: 400px;
    }

    .clkPlate {
        position: absolute;
        top: 230px;
        left: 380px;
        width: 83px;
        height: 40px;
        line-height: 30px;
        text-align: center;
        font-size: 11px;
        font-weight: 700;
        color: #000;
        background-image: url(../assets/img/cph.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 4px;
        box-sizing: border-box;
        pointer-events: none;
    }

    .yclkVideo {
        top: 70px;
        left: 720px;
        z-index: 900;
    }

    .camera {
        position: absolute;
        left: 600px;
        margin-top: 40px;
        width: 33px;
        height: 231px;
        background-image: url(../assets/img/backCourt-monitor@2x.png);
        background-size: 100% 100%;

        .cameraClick {
            position: absolute;
            top: 0;
            width: 33px;
            height: 40px;
            cursor: pointer;
        }
    }

    .backCourt-em {
        position: absolute;
        left: 650px;
        margin-top: 64px;
        width: 67px;
        height: 156px;
        background-image: url(../assets/img/backCourt-em@2x.png);
        background-size: 100% 100%;

        .emCon {
            width: 60px;
            height: 30px;
            margin-top: 42px;
            font-size: 10px;
            margin-left: 2px;
            text-align: center;
            transform: rotate(8deg);
            color: #fd3b4f;

            // overflow: hidden;
            .el-carousel {
                height: 100%;
            }
        }
    }

    .italics {
        position: absolute;
        bottom: 180px;
        left: 20px;
        width: 300px;
        height: 90px;
        text-align: center;
        transform: skewX(-4deg) rotate(9deg);

        .el-row {
            height: 30%;
            color: #fffefe;
            font-weight: bold;

            .el-col-12 {
                height: 100%;

                div {
                    line-height: 24px;
                    font-size: 12px;
                    font-family: Microsoft YaHei;

                    span {
                        color: #fff721;
                    }
                }
            }

            .el-col-24 {
                text-align-last: left;
                padding-left: 25px;
                font-size: 14px;

                span {
                    color: #fff721;
                }
            }
        }

        .italicsTitle {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #fffefe;
        }
    }

    .transportWave {
        position: absolute;
        right: 0;
        bottom: 50px;
        z-index: inherit;
        width: 800px;
        height: 60px;

        div {
            float: left;
            font-size: 14px;
            color: #fff;
            cursor: pointer;

            span {
                display: inline-block;
                margin-left: 10px;
                color: #fff721;
                font-weight: 700;
            }

            &:hover {
                text-shadow: 0 0 8px rgba(255, 247, 33, 0.6);
            }
        }
    }

    .Wave1 {
        position: absolute;
        top: -110px;
        left: 54px;
        transform: rotate(-15deg);
    }

    .Wave2 {
        position: absolute;
        top: -158px;
        left: 170px;
        transform: rotate(-25deg);
    }

    .Wave3 {
        position: absolute;
        top: -226px;
        left: 290px;
        transform: rotate(-30deg);
    }

    .Wave4 {
        position: absolute;
        top: -270px;
        left: 406px;
        transform: rotate(-16deg);

        span {
            position: absolute;
            top: 3px;
            transform: rotate(10deg);
        }
    }

    .Wave5 {
        position: absolute;
        top: -294px;
        right: 150px;

        span {
            position: absolute;
            top: 4px;
            width: 100px;
            transform: rotate(6deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/backconrt.vue